import { cn } from '@/lib/cn';
import type { PiStatus } from '@/types';

const LABEL: Record<PiStatus, string> = {
  draft: 'Draft',
  sent: 'Sent',
  accepted: 'Accepted',
  lost: 'Lost',
};

export function StatusBadge({ status }: { status: PiStatus }) {
  return (
    <span className={cn('badge', `status-${status}`)}>{LABEL[status]}</span>
  );
}
